import { Button, DialogTrigger } from '@fluentui/react-components';
import { CustomerItemStatus } from '../../../../store/features/customerUpdates/customerUpdatesSlice';
import { useTranslation } from 'react-i18next';

export interface CustomerUpdatesDialogButtonsProps {
    notifiedStatus?: CustomerItemStatus;
    onUnableToNotify?: () => void;
    onNotified?: () => void;
}

const CustomerUpdatesDialogButtons: React.FC<
    CustomerUpdatesDialogButtonsProps
> = ({ notifiedStatus, onUnableToNotify, onNotified }) => {
    const { t } = useTranslation();

    return (
        <>
            {onUnableToNotify && (
                <Button
                    appearance={'secondary'}
                    disabled={
                        !notifiedStatus || notifiedStatus !== 'NotNotified'
                    }
                    onClick={onUnableToNotify}
                >
                    {t('CustomerDialog_UnableToNotifyButton')}
                </Button>
            )}
            {onNotified && (
                <DialogTrigger action="close" disableButtonEnhancement>
                    <Button
                        appearance="primary"
                        disabled={
                            !notifiedStatus || notifiedStatus === 'Notified'
                        }
                        onClick={onNotified}
                    >
                        {t('CustomerDialog_NotifiedButton')}
                    </Button>
                </DialogTrigger>
            )}
        </>
    );
};

export default CustomerUpdatesDialogButtons;
